import { GridToolbarContainer, GridToolbarContainerProps } from '@mui/x-data-grid-pro'

export function DataGridToolbarContainer(props: GridToolbarContainerProps) {
  return <GridToolbarContainer sx={{ borderBottom: 1, borderBottomColor: 'divider', p: 1 }} {...props} />
}
